import classnames from 'classnames'
import { useTheme } from 'next-themes'
import { ReactNode } from 'react'
import styles from './IconTheme.module.scss'

type Props = {
  icon: ReactNode;
}

export function IconTheme({ icon }: Props) {
  const theme = useTheme()
  return <span className={classnames(styles.icon, theme.resolvedTheme === 'light' ? styles.light : styles.dark)}>{icon}</span>
}
